export default {
    'en': {
        'rb.gui.upload': 'Upload',
        'rb.gui.menuBar.notConnected': 'Not Connected',
        'rb.gui.menuBar.drivers': 'Serial port drivers',
        'rb.gui.menuBar.plugins': 'Plugins',
        'rb.gui.menuBar.connected': 'Connected',
        'rb.gui.menuBar.disconnect': 'Disconnect',
        'rb.gui.menuBar.factoryReset': 'Factory Reset',
        'rb.gui.menuBar.account': 'Account',
        'rb.gui.serialConnectionModal.connect': 'Connect',
        'rb.gui.serialConnectionModal.choose': 'Please Choose...',
        'rb.gui.serialConnectionModal.usbConnection': 'USB Connection',
        'rb.gui.accoutModal.myAccount': 'My Account',
        'rb.gui.accoutModal.login': 'Log In',
        'rb.gui.accoutModal.signup': 'Sign Up',
        'rb.gui.accoutModal.email': 'Email address',
        'rb.gui.accoutModal.password': 'Password',
        'rb.gui.accoutModal.username': 'Username',
        'rb.gui.accoutModal.emailValidMsg': 'Please enter a valid email address',
        'rb.gui.accountModal.passwordValidMsg': 'Please enter a value between 6 and 16 characters long',
        'rb.gui.accountModal.usernameValidMsg': 'Username must contain only letters, numbers, hyphens and underscores between 6 and 16 characters long',
        'robot.qscout': 'qscout',
        'robot.qoopers': 'qoopers',
        'robot.motionChange1': 'run [DIRECTION] at speed [SPEED]',
        'robot.motionChange2': 'set onboard motor [MOTOR] [CLOCKWISE] speed [SPEED]',
        'robot.motionChange3': 'set servo motor [PORT] connector [MOTOR] angle [ANGLE]',
        'robot.motionChange4': 'set servo motor [PORT] M1 angle [ANGLE1], M2 angle [ANGLE2]',
        'robot.motionChange5': 'set external motor [PORT] speed1 [SPEED1] speed2 [SPEED2]',
        'robot.motionChange6': 'set DC motor [PORT] connector [MOTOR] [CLOCKWISE] to move at speed [SPEED]',
        'robot.motionChange7': 'stop moving',
        'robot.lightChange1': 'set [LIGHT] light in LED panel to color [COLOR]',
        'robot.lightChange2': 'set [LIGHT] light in LED panel to color R[RED] G[GREEN] B[BLUE]',
        'robot.lightChange3': 'set LED Matrix [PORT] show icon [TEXT]',
        'robot.lightChange4': 'show drawing [PORT] draw [ICON]',
        'robot.lightChange5': 'set LED Matrix [PORT] show image [MATRIX]',
        'robot.lightChange6': 'set RGB Matrix [PORT] show image [MATRIX]',
        'robot.lightChange7': 'set color LED matric [PORT] display text [TEXT] background [BGCOLOR] text [COLOR]',
        'robot.lightChange8': 'set [PORT] ultrasonic light to color [COLOR]',
        'robot.lightChange9': 'set [PORT] the ultrasonic red [RED] green [GREEN] blue [BLUE]',
        'robot.musicChange1': 'play note [TONE] for [BAET] beats',
        'robot.musicChange2': 'MP3 [PORT] [PLAY]',
        'robot.musicChange3': 'MP3 [PORT] volume [VOLUME]',
        'robot.sensorChange1': 'read ultrasonic sensor [PORT]',
        'robot.sensorChange2': 'read line follower sensor [PORT]',
        'robot.sensorChange3': 'read light sensor [PORT]',
        'robot.sensorChange4': 'read sound sensor [PORT]',
        'robot.sensorChange5': 'read temperature sensor [PORT]',
        'robot.sensorChange6': 'read humidity sensor [PORT]',
        'robot.sensorChange7': 'read [PORT] gyro sensor [ROLLER] angle',
        'robot.sensorChange8': 'read PIR motion sensor [PORT]',
        'robot.sensorChange9': '[PORT] color sensor detect [COLOR]',
        'robot.sensorChange10': 'read [PORT] grayscale value from color sensor',
        'robot.sensorChange11': 'is the [PORT] button [BUTTON] pressed?',
        'robot.sensorChange12': '[PORT] get the key value of the touch screen',
        'robot.sensorChange13': 'pressed in robot panel?',
        'robot.light1': 'double',
        'robot.light2': 'left',
        'robot.light3': 'right',
        'robot.port1': 'port1',
        'robot.port2': 'port2',
        'robot.port3': 'port3',
        'robot.port4': 'port4',
        'robot.port5': 'port5',
        'robot.port6': 'port6',
        'robot.port7': 'port7',
        'robot.port8': 'port8',
        'robot.direction1': 'forward',
        'robot.direction2': 'backward',
        'robot.direction3': 'turn left',
        'robot.direction4': 'turn right',
        'robot.direction5': 'clockwise',
        'robot.direction6': 'anticlockwise',
        'robot.beat1': 'Half',
        'robot.beat2': 'Quarter',
        'robot.beat3': 'Eighth',
        'robot.beat4': 'Whole',
        'robot.beat5': 'Double',
        'robot.play1': 'play sound',
        'robot.play2': 'pause',
        'robot.play3': 'previous sound',
        'robot.play4': 'next sound',
        'robot.roller1': 'X',
        'robot.roller2': 'Y',
        'robot.roller3': 'Z',
        'robot.color1': 'red',
        'robot.color2': 'yellow',
        'robot.color3': 'green',
        'robot.color4': 'blue',
        'robot.color5': 'purple',
        'robot.color6': 'white',
        'robot.color7': 'colorless',
        'robot.color8': 'indigo',
        'robot.color9': 'pink'
    },
    'zh-cn': {
        'rb.gui.upload': '上传至设备',
        'rb.gui.menuBar.notConnected': '未连接',
        'rb.gui.menuBar.drivers': '串口驱动',
        'rb.gui.menuBar.plugins': '插件',
        'rb.gui.menuBar.connected': '已连接',
        'rb.gui.menuBar.disconnect': '断开连接',
        'rb.gui.menuBar.factoryReset': '恢复出厂固件',
        'rb.gui.menuBar.account': '账号',
        'rb.gui.serialConnectionModal.connect': '连接',
        'rb.gui.serialConnectionModal.choose': '请选择...',
        'rb.gui.serialConnectionModal.usbConnection': 'USB 连接',
        'rb.gui.accoutModal.myAccount': '我的账号',
        'rb.gui.accoutModal.login': '登录',
        'rb.gui.accoutModal.signup': '注册',
        'rb.gui.accoutModal.email': '电子邮箱',
        'rb.gui.accoutModal.password': '密码',
        'rb.gui.accoutModal.username': '用户名',
        'rb.gui.accoutModal.emailValidMsg': '请输入一个合法的邮箱地址',
        'rb.gui.accountModal.passwordValidMsg': '请输入一个长度为6-16的值',
        'rb.gui.accountModal.usernameValidMsg': '用户名只允许为一个只包含字母、数字、连字符和下划线且长度为6-16的值',
        'robot.qscout': 'Q侦查兵',
        'robot.qoopers': 'Q军团',
        'robot.motionChange1': '设置 [DIRECTION] 运动，速度为 [SPEED]',
        'robot.motionChange2': '设置板载电机 [MOTOR] [CLOCKWISE] 运动，速度为 [SPEED]',
        'robot.motionChange3': '设置舵机 [PORT] 插头[MOTOR] 角度为 [ANGLE]',
        'robot.motionChange4': '设置舵机 [PORT] M1角度为[ANGLE1] M2角度为 [ANGLE2]',
        'robot.motionChange5': '设置外置电机 [PORT] 速度1 [SPEED1]，速度2 [SPEED2]',
        'robot.motionChange6': '设置电机 [PORT] 插头[MOTOR] [CLOCKWISE] 运动，速度为 [SPEED]',
        'robot.motionChange7': '停止板载电机运动',
        'robot.lightChange1': '设置板载[LIGHT]颜色为[COLOR]',
        'robot.lightChange2': '设置板载[LIGHT] 红[RED] 绿[GREEN] 蓝[BLUE]',
        'robot.lightChange3': '设置LED矩阵[PORT] 显示文字 [TEXT]',
        'robot.lightChange4': '设置LED矩阵[PORT] 显示图标 [MATRIX]',
        'robot.lightChange5': '设置LED矩阵[PORT] 显示图案 [MATRIX]',
        'robot.lightChange6': '设置彩色LED矩阵[PORT] 显示图案 [MATRIX]',
        'robot.lightChange7': '设置彩色LED矩阵[PORT] 显示文字 [TEXT] 背景 [BGCOLOR] 文字 [COLOR]',
        'robot.lightChange8': '设置超声波灯 [PORT] 颜色为 [COLOR]',
        'robot.lightChange9': '设置超声波灯 [PORT] 红[RED] 绿[GREEN] 蓝[BLUE]',
        'robot.musicChange1': '播放[TONE] 音调 [BAET] 节拍',
        'robot.musicChange2': 'MP3模块 [PORT] [PLAY]',
        'robot.musicChange3': 'MP3模块 [PORT] 音量为 [VOLUME]',
        'robot.sensorChange1': '[PORT] 超声波传感器数值（cm）',
        'robot.sensorChange2': '[PORT] 巡线传感器数值',
        'robot.sensorChange3': '[PORT] 光线传感器数值',
        'robot.sensorChange4': '[PORT] 声音传感器数值',
        'robot.sensorChange5': '[PORT] 温度传感器数值',
        'robot.sensorChange6': '[PORT] 湿度传感器数值',
        'robot.sensorChange7': '[PORT] 获取陀螺仪传感器数值 [ROLLER] 转动角度',
        'robot.sensorChange8': '[PORT] 人体热式红外传感器数值',
        'robot.sensorChange9': '[PORT] 检测颜色 [COLOR]',
        'robot.sensorChange10': '[PORT] 颜色传感器灰度值',
        'robot.sensorChange11': '[PORT] 触摸屏按键 [BUTTON] 是否按下？',
        'robot.sensorChange12': '[PORT] 获取触摸屏按键值',
        'robot.sensorChange13': '主板顶部按钮是否按下？',
        'robot.light1': '双灯',
        'robot.light2': '左灯',
        'robot.light3': '右灯',
        'robot.port1': '端口1',
        'robot.port2': '端口2',
        'robot.port3': '端口3',
        'robot.port4': '端口4',
        'robot.port5': '端口5',
        'robot.port6': '端口6',
        'robot.port7': '端口7',
        'robot.port8': '端口8',
        'robot.direction1': '向前',
        'robot.direction2': '向后',
        'robot.direction3': '左转',
        'robot.direction4': '右转',
        'robot.direction5': '顺时针',
        'robot.direction6': '逆时针',
        'robot.beat1': '二分之一',
        'robot.beat2': '四分之一',
        'robot.beat3': '八分之一',
        'robot.beat4': '整拍',
        'robot.beat5': '双拍',
        'robot.play1': '播放歌曲',
        'robot.play2': '暂停播放',
        'robot.play3': '上一首',
        'robot.play4': '下一首',
        'robot.roller1': 'X轴',
        'robot.roller2': 'Y轴',
        'robot.roller3': 'Z轴',
        'robot.color1': '红色',
        'robot.color2': '黄色',
        'robot.color3': '绿色',
        'robot.color4': '蓝色',
        'robot.color5': '紫色',
        'robot.color6': '白色',
        'robot.color7': '无色',
        'robot.color8': '青色',
        'robot.color9': '粉色'
    },
    'es': {
        'rb.gui.upload': 'Cargar al dispositivo',
        'rb.gui.menuBar.notConnected': 'No conectado',
        'rb.gui.menuBar.drivers': 'Controlador de puerto serie',
        'rb.gui.menuBar.plugins': 'plugin',
        'rb.gui.menuBar.connected': 'Conectado',
        'rb.gui.menuBar.disconnect': 'Aceptar',
        'rb.gui.menuBar.factoryReset': 'Restaurar firmware de fábrica',
        'rb.gui.menuBar.account': '账号',
        'rb.gui.serialConnectionModal.connect': 'Conexión',
        'rb.gui.serialConnectionModal.choose': 'Por favor seleccione ...',
        'rb.gui.serialConnectionModal.usbConnection': 'USB Conexión',
        'rb.gui.accoutModal.myAccount': '我的账号',
        'rb.gui.accoutModal.login': '登录',
        'rb.gui.accoutModal.signup': '注册',
        'rb.gui.accoutModal.email': '电子邮箱',
        'rb.gui.accoutModal.password': '密码',
        'rb.gui.accoutModal.username': '用户名',
        'rb.gui.accoutModal.emailValidMsg': '请输入一个合法的邮箱地址',
        'rb.gui.accountModal.passwordValidMsg': '请输入一个长度为6-16的值',
        'rb.gui.accountModal.usernameValidMsg': '用户名只允许为一个只包含字母、数字、连字符和下划线且长度为6-16的值',
        'robot.qscout': 'Q-scout',
        'robot.qoopers': 'Qooper',
        'robot.motionChange1': '[DIRECTION] a una velocidad de [SPEED] rpm',
        'robot.motionChange2': 'mover motor [MOTOR] [CLOCKWISE] a una velocidad de [SPEED] rpm',
        'robot.motionChange3': 'mover servo [PORT] [MOTOR] a un ángulo de [ANGLE] grados',
        'robot.motionChange4': 'mover servo [PORT] M1: [ANGLE1] grados y M2: [ANGLE2] grados',
        'robot.motionChange5': 'mover motor externo [PORT] M1: [SPEED1] rpm M2: [SPEED2] rpm',
        'robot.motionChange6': 'mover motor externo [PORT] [MOTOR] en [CLOCKWISE] a una velocidad de [SPEED] rpm',
        'robot.motionChange7': 'detener movimiento',
        'robot.lightChange1': 'establecer LED [LIGHT] de color [COLOR]',
        'robot.lightChange2': 'establecer LED [LIGHT] de color R [RED] G [GREEN] B [BLUE]',
        'robot.lightChange3': 'mostrar en matriz de LED del [PORT] el texto [TEXT]',
        'robot.lightChange4': 'mostrar en matriz de LED del [PORT] el ícono [MATRIX]',
        'robot.lightChange5': 'mostrar en matriz de LED del [PORT] el dibujo [MATRIX]',
        'robot.lightChange6': 'mostrar en matriz RGB del [PORT] el dibujo [MATRIX]',
        'robot.lightChange7': 'mostrar en matriz RGB del [PORT] el texto [TEXT] de color [BGCOLOR] en fondo [COLOR]',
        'robot.lightChange8': 'establecer luz del sensor ultrasónico en [PORT] de color [COLOR]',
        'robot.lightChange9': 'establecer luz del sensor ultrasónico en [PORT] de color R [RED] G [GREEN] B [BLUE]',
        'robot.musicChange1': 'reproducir la nota [TONE] durante [BAET] pulsos',
        'robot.musicChange2': 'módulo MP3 del [PORT], [PLAY]',
        'robot.musicChange3': 'módulo MP3 del [PORT], volúmen [VOLUME]',
        'robot.sensorChange1': 'valor del sensor ultrasónico (cm) del [PORT]',
        'robot.sensorChange2': 'valor del sensor siguelíneas del [PORT]',
        'robot.sensorChange3': 'valor del sensor de luz del [PORT]',
        'robot.sensorChange4': 'valor del sensor de sonido del [PORT]',
        'robot.sensorChange5': 'valor del sensor de temperatura [PORT] ',
        'robot.sensorChange6': 'valor del sensor de humedad [PORT]',
        'robot.sensorChange7': 'valor del giroscopio del [PORT] en eje [ROLLER]',
        'robot.sensorChange8': 'valor del sensor de movimiento PIR del [PORT]',
        'robot.sensorChange9': '¿[PORT] color detectado [COLOR]?',
        'robot.sensorChange10': 'valor en escala de grises del sensor de color del [PORT]',
        'robot.sensorChange11': '[PORT] Botón de pantalla táctil [BUTTON] ¿Está presionado?',
        'robot.sensorChange12': '[PORT] Obtener el valor del sensor multitáctil',
        'robot.sensorChange13': '¿botón superior de la placa presionado?',
        'robot.light1': 'izquierdo y derecho',
        'robot.light2': 'izquierdo',
        'robot.light3': 'derecho',
        'robot.port1': 'Puerto1',
        'robot.port2': 'Puerto2',
        'robot.port3': 'Puerto3',
        'robot.port4': 'Puerto4',
        'robot.port5': 'Puerto5',
        'robot.port6': 'Puerto6',
        'robot.port7': 'Puerto7',
        'robot.port8': 'Puerto8',
        'robot.direction1': 'ir hacia adelante',
        'robot.direction2': 'ir hacia atrás',
        'robot.direction3': 'girar a la izquierda',
        'robot.direction4': 'girar a la derecha',
        'robot.direction5': 'Sentido Horario',
        'robot.direction6': 'Sentido Antihorario',
        'robot.beat1': '0,5',
        'robot.beat2': '0,25',
        'robot.beat3': '0,125',
        'robot.beat4': '1',
        'robot.beat5': '2',
        'robot.play1': 'reproducir',
        'robot.play2': 'pausar reproducción',
        'robot.play3': 'pista anterior',
        'robot.play4': 'pista siguiente',
        'robot.roller1': 'X',
        'robot.roller2': 'Y',
        'robot.roller3': 'Z',
        'robot.color1': 'Rojo',
        'robot.color2': 'Amarillo',
        'robot.color3': 'Verde',
        'robot.color4': 'Azul',
        'robot.color5': 'Morado',
        'robot.color6': 'Blanco',
        'robot.color7': 'Incoloro',
        'robot.color8': 'Cian',
        'robot.color9': 'Rosa'
    },
    'es-419': {
        'rb.gui.upload': 'Cargar al dispositivo',
        'rb.gui.menuBar.notConnected': 'No conectado',
        'rb.gui.menuBar.drivers': 'Controlador de puerto serie',
        'rb.gui.menuBar.plugins': 'plugin',
        'rb.gui.menuBar.connected': 'Conectado',
        'rb.gui.menuBar.disconnect': 'Aceptar',
        'rb.gui.menuBar.factoryReset': 'Restaurar firmware de fábrica',
        'rb.gui.menuBar.account': '账号',
        'rb.gui.serialConnectionModal.connect': 'Conexión',
        'rb.gui.serialConnectionModal.choose': 'Por favor seleccione ...',
        'rb.gui.serialConnectionModal.usbConnection': 'USB Conexión',
        'rb.gui.accoutModal.myAccount': '我的账号',
        'rb.gui.accoutModal.login': '登录',
        'rb.gui.accoutModal.signup': '注册',
        'rb.gui.accoutModal.email': '电子邮箱',
        'rb.gui.accoutModal.password': '密码',
        'rb.gui.accoutModal.username': '用户名',
        'rb.gui.accoutModal.emailValidMsg': '请输入一个合法的邮箱地址',
        'rb.gui.accountModal.passwordValidMsg': '请输入一个长度为6-16的值',
        'rb.gui.accountModal.usernameValidMsg': '用户名只允许为一个只包含字母、数字、连字符和下划线且长度为6-16的值',
        'robot.qscout': 'Q-scout',
        'robot.qoopers': 'Qooper',
        'robot.motionChange1': '[DIRECTION] a una velocidad de [SPEED] rpm',
        'robot.motionChange2': 'mover motor [MOTOR] [CLOCKWISE] a una velocidad de [SPEED] rpm',
        'robot.motionChange3': 'mover servo [PORT] [MOTOR] a un ángulo de [ANGLE] grados',
        'robot.motionChange4': 'mover servo [PORT] M1: [ANGLE1] grados y M2: [ANGLE2] grados',
        'robot.motionChange5': 'mover motor externo [PORT] M1: [SPEED1] rpm M2: [SPEED2] rpm',
        'robot.motionChange6': 'mover motor externo [PORT] [MOTOR] en [CLOCKWISE] a una velocidad de [SPEED] rpm',
        'robot.motionChange7': 'detener movimiento',
        'robot.lightChange1': 'establecer LED [LIGHT] de color [COLOR]',
        'robot.lightChange2': 'establecer LED [LIGHT] de color R [RED] G [GREEN] B [BLUE]',
        'robot.lightChange3': 'mostrar en matriz de LED del [PORT] el texto [TEXT]',
        'robot.lightChange4': 'mostrar en matriz de LED del [PORT] el ícono [MATRIX]',
        'robot.lightChange5': 'mostrar en matriz de LED del [PORT] el dibujo [MATRIX]',
        'robot.lightChange6': 'mostrar en matriz RGB del [PORT] el dibujo [MATRIX]',
        'robot.lightChange7': 'mostrar en matriz RGB del [PORT] el texto [TEXT] de color [BGCOLOR] en fondo [COLOR]',
        'robot.lightChange8': 'establecer luz del sensor ultrasónico en [PORT] de color [COLOR]',
        'robot.lightChange9': 'establecer luz del sensor ultrasónico en [PORT] de color R [RED] G [GREEN] B [BLUE]',
        'robot.musicChange1': 'reproducir la nota [TONE] durante [BAET] pulsos',
        'robot.musicChange2': 'módulo MP3 del [PORT], [PLAY]',
        'robot.musicChange3': 'módulo MP3 del [PORT], volúmen [VOLUME]',
        'robot.sensorChange1': 'valor del sensor ultrasónico (cm) del [PORT]',
        'robot.sensorChange2': 'valor del sensor siguelíneas del [PORT]',
        'robot.sensorChange3': 'valor del sensor de luz del [PORT]',
        'robot.sensorChange4': 'valor del sensor de sonido del [PORT]',
        'robot.sensorChange5': 'valor del sensor de temperatura [PORT] ',
        'robot.sensorChange6': 'valor del sensor de humedad [PORT]',
        'robot.sensorChange7': 'valor del giroscopio del [PORT] en eje [ROLLER]',
        'robot.sensorChange8': 'valor del sensor de movimiento PIR del [PORT]',
        'robot.sensorChange9': '¿[PORT] color detectado [COLOR]?',
        'robot.sensorChange10': 'valor en escala de grises del sensor de color del [PORT]',
        'robot.sensorChange11': '[PORT] Botón de pantalla táctil [BUTTON] ¿Está presionado?',
        'robot.sensorChange12': '[PORT] Obtener el valor del sensor multitáctil',
        'robot.sensorChange13': '¿botón superior de la placa presionado?',
        'robot.light1': 'izquierdo y derecho',
        'robot.light2': 'izquierdo',
        'robot.light3': 'derecho',
        'robot.port1': 'Puerto1',
        'robot.port2': 'Puerto2',
        'robot.port3': 'Puerto3',
        'robot.port4': 'Puerto4',
        'robot.port5': 'Puerto5',
        'robot.port6': 'Puerto6',
        'robot.port7': 'Puerto7',
        'robot.port8': 'Puerto8',
        'robot.direction1': 'ir hacia adelante',
        'robot.direction2': 'ir hacia atrás',
        'robot.direction3': 'girar a la izquierda',
        'robot.direction4': 'girar a la derecha',
        'robot.direction5': 'Sentido Horario',
        'robot.direction6': 'Sentido Antihorario',
        'robot.beat1': '0,5',
        'robot.beat2': '0,25',
        'robot.beat3': '0,125',
        'robot.beat4': '1',
        'robot.beat5': '2',
        'robot.play1': 'reproducir',
        'robot.play2': 'pausar reproducción',
        'robot.play3': 'pista anterior',
        'robot.play4': 'pista siguiente',
        'robot.roller1': 'X',
        'robot.roller2': 'Y',
        'robot.roller3': 'Z',
        'robot.color1': 'Rojo',
        'robot.color2': 'Amarillo',
        'robot.color3': 'Verde',
        'robot.color4': 'Azul',
        'robot.color5': 'Morado',
        'robot.color6': 'Blanco',
        'robot.color7': 'Incoloro',
        'robot.color8': 'Cian',
        'robot.color9': 'Rosa'
    }
};
